export default __webpack_public_path__ + "static/Digital-superiority-3ca5d8674227b5a4717a8dd2893c73ab.webp";